import { post, get } from '../util/crmAxios'
import { getBasicUrls } from '../util/config'

const schoolm = getBasicUrls().schoolm
const newAgentManage = getBasicUrls().newAgentManage

// 电子账户---消费记录接口
export const expensesRecord = (params) => post('/erp/school/expensesRecord', params)

// 电子账户---充值记录接口
export const rechargeLog = (params) => post('/erp/school/rechargeLog', params)

// 电子账户---退转记录接口
export const refundLog = (params) => post('/erp/school/refundLog', params)

// 电子账户---余额接口
export const balance = (params) => post('/erp/school/balance', params)

// 电子账户---校区充值接口
export const schoolPay = (params) => post('/erp/school/schoolPay', params)

// 电子账户---充值时获取充值状态接口getSchoolOrderStatus
export const getSchoolOrderStatus = (orderNo) => get('/erp/school/getSchoolOrderStatus', orderNo)

//电子账户 --开票基本信息
export const getChargeEinvoceBaseInfo = (orderNo) => get('/invoice/getChargeEinvoceBaseInfo', orderNo)

//电子账户 --发票开票
export const createChargeInvoice = (params) => post('/invoice/createChargeInvoice', params)

//电子发票--开票记录列表
export const getChargeInvoiceList = (params) => post('/invoice/getChargeInvoiceList', params)

//电子账户 ---发票详情
export const getChargeInvoiceDetail = (orderNo) => get('/invoice/getChargeInvoiceDetail', orderNo)

//电子账户 --- 作废发票
export const einvoiceRedFlush = (params) => post('/invoice/einvoiceRedFlush', params)

//电子账户 --- 获取时间判断是否禁止开票

export const getAppConfig = (orderNo) => get('/base/sysconfig/getAppConfig', orderNo)
//知识漏洞大体检 测评组查询
export const selectTestClass = (params) => post('/crm/dl_manager/selectTestClass', params)

export const getQuestionNum = (params) => post('/crm/dl_manager/getQuestionNum', params)

//知识漏洞大体检 测评组新增
export const addTestClass = (params) => post('/crm/dl_manager/addTestClass', params)

// 知识漏洞大体检 测评组查看学生
export const selectTestClassStudent = (params) => post('/crm/dl_manager/selectTestClassStudent', params)

//知识漏洞大体检  测评组添加学生
export const testClassAddStudent = (params) => post('/crm/dl_manager/testClassAddStudent', params)

//  知识漏洞大体检 测评报告
export const selectReport = (params) => post('/crm/dl_manager/selectReport', params)

// 知识漏洞大体检 获取DL字典
export const getDlRelated = (params) => post('/crm/dl_manager/getDlRelated', params)

// getGwPasswordStr
export const getGwPasswordStr = (params) => get('/crm/customer/getGwPasswordStr', params)

//知识漏洞大体检  测评组添加学生
export const updateTestClass = (params) => post('/crm/dl_manager/updateTestClass', params)

//知识漏洞大体检  测评组添加学生
export const queryDiversionReportListByPage = (params) => post('/crm/customer/queryDiversionReportListByPage', params)

//知识漏洞大体检  测评组添加学生
export const selectAuditionReportList = (params) => post('/erp/studentAudition/selectAuditionReportList', params)

//试听列表
export const selectStudentAudition = (params) => post('/erp/studentAudition/selectStudentAudition', params)
//邀约体验课接口
export const queryStudentLearnMachineAuditio = (params) =>
  post('/erp/studentAudition/queryStudentLearnMachineAuditio', params)

export const getReport = (params) => post('/base/common/getReport', params)

//设置学员课程分析员
export const setCourseTeacher = (params) => post('/erp/course/setCourseTeacher', params)

// 财务中心

// 代理商帐户余额
export const queryAgentAccount = (params) => get(schoolm + 'manage/agent/queryAgentAccount', params)

// 获取学习机支付地址
export const getStudyPayUrl = (params) => post('/pay/getStudyPayUrl', params)

// 获取学习机支付状态
// export const getStudyPayStatus = (params) => get('/pay/getStudyPayStatus', params);
export const getStudyPayStatus = (params) => get(schoolm + 'manage/purchase/order/getStudyPayStatus', params)

export const purchaseOrderPay = (params) => post(schoolm + 'manage/purchase/order/pay', params)

export const bankRransferPay = (params) => post(schoolm + 'manage/credit/order/pay', params)

// 查询最大代金券金额
export const queryMaxVoucherPrice = (params) => get(schoolm + 'manage/purchase/order/queryMaxVoucherPrice', params)
// 采购单初始付款
export const initPay = (params) => post(schoolm + 'manage/purchase/order/initPay', params)
// 代理商晋升信息
export const agentPromotion = (params) => get(schoolm + 'manage/promotion/agentPromotion', params)
// 获取代理商-学习机支付地址
export const agentStudyPayUrl = (params) => post(schoolm + 'manage/purchase/order/agentStudyPayUrl', params)
// 金账户-对公转账支付
export const transferPay = (params) => post(schoolm + 'manage/purchase/order/transferPay', params)
// 现金账户-对公转账支付
export const agentSingleBankPay = (params) => post(schoolm + 'manage/purchase/order/agentSingleBankPay', params)
// 金账户付款时-获取采购单信息
export const getGoldPurchaseOrder = (params) => get(schoolm + 'manage/purchase/order/getGoldPurchaseOrder', params)
// 查询金账户剩余金额
export const queryGoldMaxPrice = (params) => get(schoolm + 'manage/purchase/order/queryGoldMaxPrice', params)
// 金账户收款-采购单付款
export const goldPay = (params) => post(schoolm + 'manage/purchase/order/goldPay', params)
// 根据商品型号获取商品列表
export const getProductModel = (params) => get(schoolm + 'manage/product/getProductModel', params)
// 根据商品型号获取商品列表
export const getProductModelPrices = (params) => get(schoolm + 'manage/product/getProductModelPrices', params)
// 根据商品型号获取商品列表-借调货
export const getTransferProductModelPrices = (params) =>
  get(schoolm + 'manage/product/getTransferProductModelPrices', params)
// 获取商品型号类型-借调货
export const getTransferProductModel = (params) => get(schoolm + 'manage/product/getTransferProductModel', params)
// 根据商品型号获取商品列表-借调货
export const getProductList = params =>
  post(schoolm + "manage/warehouse/inventory/getProductList", params);
// 获取代理商-现金账户充值地址
export const agentSingleStudyPayUrl = (params) => post(schoolm + 'manage/purchase/order/agentSingleStudyPayUrl', params)
// 出库单列表
export const queryCkOrder = (params) => post(schoolm + 'manage/goodsdeliver/queryCkOrder', params)
// 出库单列表
export const queryCkAndTKOrder = (params) => post(schoolm + 'manage/goodsdeliver/queryCkAndTKOrder', params)
// 出库单导出
export const exportCkOrder = (params) => post(schoolm + 'manage/goodsdeliver/exportCkOrder', params)
// 查询最大赊货代金券金额
export const queryMaxCreditVoucherPrice = (params) => get(schoolm + 'manage/credit/order/queryMaxVoucherPrice', params)
// 赊货订单支付
export const creditOrderPay = (params) => post(schoolm + 'manage/credit/order/pay', params)
// 赊货订单-学习机支付地址
export const agentStudyCreditPayUrl = (params) => post(schoolm + 'manage/credit/order/agentStudyPayUrl', params)
// 查询最大代金券金额
export const queryDualMaxVoucherPrice = (params) => get(schoolm + 'manage/dual/order/queryDualMaxVoucherPrice', params)
// 双重订单支付
export const dualOrderPay = (params) => post(schoolm + 'manage/dual/order/pay', params)
// 查询代理商账户余额-双重订单关联代理商id
export const queryDualAgentAccount = (params) => get(schoolm + 'manage/dual/order/queryDualAgentAccount', params)
// 订单预收运费页面-获取运费信息
export const queryOrderFreight = (params) => post(schoolm + 'manage/purchase/order/queryOrderFreight', params)
// 订单预收运费页面-支付(含运费)
export const saveOrderFreight = (params) => post(schoolm + 'manage/purchase/order/saveOrderFreight', params)
// 订单支付页面-获取订单支付信息
export const queryOrderPayInfo = (params) => post(schoolm + 'manage/purchase/order/queryOrderPayInfo', params)

// 获取自提单的运费信息
export const queryLadingOrderFreight = (params) => post(newAgentManage + 'lading/queryLadingOrderFreight', params)

// 运费到付-发货接口
export const ladingDispatch = (params) => post(newAgentManage + 'lading/ladingDispatch', params)

// 运费预付-保存预付运费
export const saveLadingFreight = (params) => post(newAgentManage + 'lading/saveLadingFreight', params)

// 获取支付页面的订单信息
export const queryLadingPayInfo = (params) => post(newAgentManage + 'lading/queryLadingPayInfo', params)

// 自提单支付
export const ladingPay = (params) => post(newAgentManage + 'lading/ladingPay', params)

// 选择支付宝微信获取支付链接
export const ladingPayUrl = (params) => post(newAgentManage + 'lading/ladingPayUrl', params)

// 获取换货单的运费信息
export const querySwapOrderFreight = (params) => post(newAgentManage + 'swap/querySwapOrderFreight', params)

// 运费预付-保存预付运费
export const saveSwapFreight = (params) => post(newAgentManage + 'swap/saveSwapFreight', params)

// 新增判断是否是代理商
export const checkRegionCampus = (params) => get(schoolm + 'manage/credit/order/checkRegionCampus', params)

//新增判断是否是省代
export const checkCreditOrderCampusId = (params) => get(schoolm + 'manage/credit/order/checkCreditOrderCampusId', params)

//新增判断发货方是否是省代
export const checkProvinceCampus = (params) => get(schoolm + 'manage/credit/order/checkProvinceCampus', params)

// 公告中心-查看最新一条消息
export const queryForNewNotice = (params) => post(schoolm + 'notice/queryForNewNotice', params)

// 查询经销商紧急联系人
export const queryEmergencyContactList = (params) => post(schoolm + 'notice/queryEmergencyContactList', params)

// 查询紧急联系人是否弹框
export const queryShowWindows = (params) => post(schoolm + 'notice/queryShowWindows', params)

// 更新经销商紧急联系人
export const updEmergencyContact = (params) => post(schoolm + 'notice/updEmergencyContact', params)

// 验证是否需要修改商品配比
export const checkNeedModify = (params) => get(schoolm + 'manage/agent/autoOrderConfig/checkNeedModify', params)

// 经销商系统-校验学员是否限制功能
export const checkAccountRestrictFunction = (params) => post(schoolm + 'manage/agent/tool/checkAccountRestrictFunction', params)